var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    { staticClass: "view-growers" },
    [
      _c(
        "ui-heading",
        { attrs: { title: "Mosselkwekers", icon: "fa-building" } },
        [
          _c(
            "ui-button",
            {
              attrs: {
                color: "positive",
                icon: "magicon-plus",
                route: "grower-add",
              },
            },
            [_vm._v("Kweker toevoegen")]
          ),
          _c("ui-searchbar", {
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c(
        "ui-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            clickable: "",
            placeholder: _vm.growers && !_vm.growers.items.length,
            total: _vm.$safe("growers.totalCount"),
            visible: _vm.paging.limit,
          },
          on: { page: _vm.switchPage },
        },
        [
          _c(
            "ui-table-header",
            [
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "name" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Naam")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "3", field: "address" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Adres")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "phoneNumber" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Telefoonnummer")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "1", field: "postcode" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Postcode")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "3", field: "email" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("E-mail adres")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "waterInsightsAccessible" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Water inzichten")]
              ),
              _c(
                "ui-th",
                {
                  attrs: { weight: "2", field: "shared" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Leveren aan andere kwekers")]
              ),
              _c("ui-th", { attrs: { weight: "1" } }),
            ],
            1
          ),
          _vm._l(_vm.$safe("growers.items"), function (grower) {
            return _c("ui-tr", { key: grower.id, attrs: { click: "edit" } }, [
              _c("td", [_vm._v(_vm._s(grower.name))]),
              _c("td", [_vm._v(_vm._s(grower.address))]),
              _c("td", [_vm._v(_vm._s(grower.phoneNumber))]),
              _c("td", [_vm._v(_vm._s(grower.postcode))]),
              _c("td", [_vm._v(_vm._s(grower.email))]),
              _c("td", [
                _vm._v(_vm._s(_vm._f("bool")(grower.waterInsightsAccessible))),
              ]),
              _c("td", [_vm._v(_vm._s(_vm._f("bool")(grower.shared)))]),
              _c(
                "td",
                {
                  staticClass: "actions",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("ui-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Wijzigen",
                        expression: "'Wijzigen'",
                      },
                    ],
                    attrs: {
                      icon: "magicon-edit",
                      action: "edit",
                      to: { name: "grower-edit", params: { id: grower.id } },
                    },
                  }),
                  _c("ui-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Verwijderen",
                        expression: "'Verwijderen'",
                      },
                    ],
                    attrs: { icon: "magicon-trash" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteGrower(grower.id)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }